module.exports = __webpack_public_path__ + "media/bootstrap-icons/triangle-fill-6940fa16.svg";